import { createFocusTrap } from "focus-trap";
import { module as Module } from "modujs";

export default class extends Module {
    constructor(m) {
        super(m);

        // UI
        this.$toggler = this.$("subnavToggler")[0];
        this.$subnav = this.$("subnav")[0];
        this.$close = this.$("overlay")[0];

        this.isOpen = false;

        this.onClickBind = this.onClick.bind(this);

        this.focusTrapOptions = {
            /**
             * There is a delay between when the class is applied
             * and when the element is focusable
             */
            checkCanFocusTrap: (trapContainers) => {
                const results = trapContainers.map((trapContainer) => {
                    return new Promise((resolve) => {
                        const interval = setInterval(() => {
                            if (
                                getComputedStyle(trapContainer).visibility !==
                                "hidden"
                            ) {
                                resolve();
                                clearInterval(interval);
                            }
                        }, 5);
                    });
                });

                // Return a promise that resolves when all the trap containers are able to receive focus
                return Promise.all(results);
            },

            onActivate: () => {
                /*                 html.classList.add(this.activeClass);
                 */
                this.el.classList.add("has-subnav-open");
                this.$toggler.classList.add("is-active");
                this.$subnav.classList.add("is-active");
                this.el.setAttribute("aria-hidden", false);

                setTimeout(() => {
                    this.$close.focus();
                }, 800);
            },

            onPostActivate: () => {
                if (this.toggler) {
                    this.toggler.setAttribute("aria-expanded", true);
                }
            },

            onDeactivate: () => {
                this.el.classList.remove("has-subnav-open");
                this.$toggler.classList.remove("is-active");
                this.$subnav.classList.remove("is-active");
                this.el.setAttribute("aria-hidden", true);
            },

            onPostDeactivate: () => {
                if (this.toggler) {
                    this.toggler.setAttribute("aria-expanded", false);
                    this.toggler = null;
                }
            },
        };

        this.events = {
            click: {
                overlay: 'close',
            },
        };

        this.closeBind = (e) => {
            if (e.key === "Escape") {
                this.close();
            }
        };
    }

    bindEvents() {
        this.$toggler.addEventListener("click", this.onClickBind);
    }

    unbindEvents() {
        this.$toggler.addEventListener("click", this.onClickBind);
    }

    init() {
        this.focusTrap = createFocusTrap(this.el, this.focusTrapOptions);

        document.addEventListener("keyup", this.closeBind);

        this.bindEvents();
    }

    open(args) {
        if (this.isOpen) return;

        this.isOpen = true;

        this.focusTrap?.activate?.();
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    close(args) {
        if (!this.isOpen) return;

        this.isOpen = false;

        this.focusTrap?.deactivate?.();
    }

    onClick() {
        this.toggle();
    }

    destroy() {
        this.focusTrap?.deactivate?.({
            returnFocus: false,
        });

        document.removeEventListener("keyup", this.closeBind);

        super.destroy();

        this.unbindEvents();
    }
}
